<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/">Início</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Meus dados / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card card-table shadow mb-4">

                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <fieldset>
                                    <legend>Dados gerais</legend>
                                    <div class="row mt-2">
                                        <div class="col-xl-2 col-md-2 col-sm-12">
                                            <label for="">Matrícula</label>
                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client.mat != ''" class="form-control"
                                                    v-model="client.mat" disabled>
                                                <input type="text" v-else class="form-control" value="Não informada"
                                                    disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">CNPJ*</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" v-model="client.document"
                                                    disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Razão Social*</label>
                                            <input type="text" class="form-control" v-model="client.name" disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Nome Fantasia</label>
                                            <input type="text" class="form-control" v-if="client.name_fantasy != ''"
                                                v-model="client.name_fantasy" disabled>
                                            <input type="text" class="form-control" v-else value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">NIRE</label>
                                            <input type="text" class="form-control" v-if="client.nire != ''"
                                                v-model="client.nire" disabled>
                                            <input type="text" class="form-control" v-else value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">CCMEI</label>
                                            <input type="text" class="form-control" v-if="client.ccmei != ''"
                                                v-model="client.ccmei" disabled>
                                            <input type="text" class="form-control" v-else value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">E-mail</label>
                                            <input type="text" v-if="client.email != ''" class="form-control"
                                                v-model="client.email" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Telefone*</label>
                                            <input type="text" v-if="client.phone != ''" class="form-control"
                                                v-model="client.phone" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend>Endereço</legend>
                                    <div class="row mt-2">
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">CEP</label>

                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client.zipcode != ''" class="form-control"
                                                    v-model="client.zipcode" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado"
                                                    disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-7 col-md-7 col-sm-12">
                                            <label for="">Endereço</label>
                                            <input type="text" v-if="client.street != ''" class="form-control"
                                                v-model="client.street" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-2 col-md-2 col-sm-12">
                                            <label for="">Nº</label>
                                            <input type="text" v-if="client.number_street != ''" class="form-control"
                                                v-model="client.number_street" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">Complemento</label>
                                            <input type="text" v-if="client.complement != ''" class="form-control"
                                                v-model="client.complement" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Bairro</label>
                                            <input type="text" v-if="client.district != ''" class="form-control"
                                                v-model="client.district" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Cidade</label>
                                            <input type="text" v-if="client.city != ''" class="form-control"
                                                v-model="client.city" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">UF</label>
                                            <input type="text" v-if="client.uf != ''" class="form-control"
                                                v-model="client.uf" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,

            gender_multiselect: '',
            client: {
                mat: '',
                document: '',
                name: '',
                name_fantasy: '',
                phone: '',
                email: '',
                nire: '',
                ccmei: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.client.document != '' && this.client.name != '' && this.client.phone != '';
        }
    },
    mounted() {
        this.isLoading = false;
        this.getclient();
    },
    beforeMount() {
        const id =  localStorage.getItem('client_id');
        this.client.id = id;
    },
    methods: {
        onCancel() { },

        async getclient() {
            const response = await api.get('/client-user/' + this.client.id)
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    this.client.document = response.data.client.document_formatted;
                    this.client.phone = response.data.client.phone_formatted;
                    this.$refs.myChild.updateTextEditor(this.client.observation);

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                });
            return response;

        },

    }
}
</script>

<style lang="scss" scoped></style>